import { RelatedMediaDto } from '@/controllers/admin/relatedMedia'

export function uniqueRelatedMedia<T extends { id: number; type?: string }> (items: T[]): T[] {
  const seen = new Set<string>()
  return items.filter(item => {
    const key = `${item.type ?? 'media'}:${item.id}`
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}

export function insertRelatedMedia (
  current: RelatedMediaDto[],
  additions: RelatedMediaDto[]
): RelatedMediaDto[] {
  const existingIds = new Set(current.map(({ id }) => id))
  const orderedAdditions = additions
    .filter(({ id }) => !existingIds.has(id))
    .sort((a, b) => new Date(b.updated ?? 0).getTime() - new Date(a.updated ?? 0).getTime())
  return [...orderedAdditions, ...current]
}

export function moveRelatedMedia (
  current: RelatedMediaDto[],
  index: number,
  destination: 'top' | 'bottom'
): RelatedMediaDto[] {
  const reordered = [...current]
  const [media] = reordered.splice(index, 1)
  if (!media) return current

  if (destination === 'top') reordered.unshift(media)
  else reordered.push(media)
  return reordered
}

export function moveRelatedMediaTo (
  current: RelatedMediaDto[],
  index: number,
  position: number
): RelatedMediaDto[] {
  const targetIndex = Math.min(Math.max(position, 1), current.length) - 1
  if (targetIndex === index) return current

  const reordered = [...current]
  const [media] = reordered.splice(index, 1)
  reordered.splice(targetIndex, 0, media)
  return reordered
}
